import * as React from 'react';

import { ContextualHelp, Dialog, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-admin-home';

const Help: React.LegacyFunctionComponentWithChildren<{ label: React.ReactNode; title?: string }> = ({
  children,
  label,
  title,
}) => {
  return (
    <ContextualHelp
      helpToggleProps={{
        'aria-label': title ?? _t('Information about the label'),
      }}
      tooltipProps={{
        closeButtonProps: {
          'aria-label': _t('Close'),
        },
      }}
      label={
        <Typography2 component="h4" variant="subtitleMedium">
          {label}
        </Typography2>
      }
    >
      {({ onClose, isExpanded = false }) => (
        <Dialog aria-describedby="dialog-content" open={isExpanded} onClose={onClose}>
          <Dialog.HeadingGroup>{title ?? _t('Additional information')}</Dialog.HeadingGroup>
          <Dialog.Content id="dialog-content">
            <Typography2 component="p">{children}</Typography2>
          </Dialog.Content>
        </Dialog>
      )}
    </ContextualHelp>
  );
};

export default Help;
